export default __webpack_public_path__ + "static/Matthew-Cholin-2-350x350-fbbb89c919c97fad83bfca5efe89f975.jpg";